<template lang="pug">
include Login.pug
</template>

<script>
import _ from "underscore"
import Api from "@/components/services/Api";
import { mapState } from 'vuex';

export default {
  name: 'Login',
  props: ["visible"],
  computed: mapState([
    "context",
  ]),
  data () {
    return {
      calling: false,
      username: "",
      password: "",
      error: null,
    }
  },
  methods: {
    toRecover() {
      this.$router.push({name: "RecoverPassword"});
    },
    tryLogin() {
      const _this = this
      this.error = null
      this.calling = true

      let redirectOnLogin = localStorage.getItem(window.PREFIX + "redirectOnLogin")
      if (redirectOnLogin && !_.isEmpty(redirectOnLogin)) {
        redirectOnLogin = JSON.parse(redirectOnLogin)
      }

      Api.auth(this.username, this.password).then(result => {
        _this.calling = false
        let token = result.data.token
        let userType = result.data.type

        // Propagate to local storage
        localStorage.setItem(window.PREFIX + "token", token)
        localStorage.setItem(window.PREFIX + "type", userType)

        // Propagate to store
        _this.$store.commit("set_token", token)
        _this.$store.commit("set_type", userType)

        if (redirectOnLogin) {
          localStorage.removeItem(window.PREFIX + "redirectOnLogin")
          _this.$router.push(redirectOnLogin)
        } else {
          // to dashboard!
          _this.$router.push({
            // ESTO DESCOMENTAR CUANDO SE IMPLEMENTE EL DASHBOARD
            // name: (userType == "professional") ? 'DashboardIndex': 'SchoolAdminMigration',
            name: (userType == "professional") ? 'DashboardAddresses': 'SchoolAdminMigration',
          });
        }

      }).catch(err => {
        // err on login : show error message
        _this.error = "Error en usuario y/o contraseña"
        _this.calling = false
      })
    }
  }
}
</script>

<style scoped lang="scss">
@import "./../../variables";
@import "./../../variables_colreps";
@import "./../../variables_mexreps";
@import "login";

@import "loginColreps";
@import "loginMexreps";
</style>




// WEBPACK FOOTER //
// src/components/login/Login.vue